var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderNav',{attrs:{"auth":_vm.$store.state.isAuth}}),_c('div',{staticClass:"wrapper wrapper__lc"},[_c('router-view',{attrs:{"name":"LcMenu"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }